import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector, batch } from 'react-redux'
import { LoadingIndicator } from '../../components/Loading'

import { getLeaderBoard } from '../../redux/actions/LeaderBoardActions'
import { getFollowList } from '../../redux/actions/FollowingActions'
import CategoriesSwitcher from '../../components/CategoriesSwitcher'
import {
  LeaderBoardCategory,
  CategoryDescriptionModal
} from '../../components/LeaderBoard'

const categoriesList = [
  {
    label: 'Monthly',
    key: 'monthly'
  },
  {
    label: 'All Time',
    key: 'allTime'
  },
  {
    label: 'New User',
    key: 'newUsers'
  }
]

const LoadingContainer = styled.div`
  width: 100vw;
  margin-top: 10vh;
`

export const LeaderBoard = () => {
  const [selectedCategory, setSelectedCategory] = useState(categoriesList[0])
  const onChange = category => {
    setSelectedCategory(category)
  }

  const dispatch = useDispatch()

  useEffect(() => {
    batch(() => {
      dispatch(getLeaderBoard())
      dispatch(getFollowList())
    })
  }, [dispatch])

  const { categories, isLoading } = useSelector(state => state.leaderBoard)

  const category = categories[selectedCategory.key]

  return (
    <div>
      <CategoriesSwitcher
        list={categoriesList}
        onChange={onChange}
        selected={selectedCategory}
      />
      {isLoading ? (
        <LoadingContainer>
          <LoadingIndicator loading />
        </LoadingContainer>
      ) : (
        category.map(subCategory => (
          <LeaderBoardCategory
            key={subCategory.type}
            period={selectedCategory.key}
            {...subCategory}
          />
        ))
      )}
      <CategoryDescriptionModal />
    </div>
  )
}
